import { Box, Card, CardBody, CardHeader, Heading, VStack } from '@chakra-ui/react'
import React from 'react'
import Profile_detail from './Profile_detail'
import PEducation from '../../Profile_new/PEducation'
import PPosition from '../../Profile_new/PPosition'

const AllApps = () => {
  return (
    <>
    <Box  width={"100%"} p={4} >
      <Card>
      <CardHeader bg="gray.100">
            <Heading as="h1" size="2xl">
              My Profile
            </Heading>
          </CardHeader>
      <CardBody>
        <VStack  width={"100%"} gap={10}>
          <Box  width={"100%"}><Profile_detail/></Box>
          {/* <Box  width={"100%"}><PEducation/></Box> */}
          <Box  width={"100%"}><PPosition/></Box>

        </VStack>
      </CardBody>
      </Card>
    </Box>
    </>
  )
}

export default AllApps
